<template>
  <b-badge v-bind="$attrs" :data-cy="dataCy">
    <slot></slot>
    <a v-if="withRemove" class="inline-block ml-2 remove" href="#" @click.prevent.stop="$emit('remove')">
      <!-- <i class="fa fa-times" /> -->
      <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10">
        <path
          :fill="fillColor"
          d="M6.895455 5l2.842897-2.842898c.348864-.348863.348864-.914488 0-1.263636L9.106534.261648c-.348864-.348864-.914489-.348864-1.263636 0L5 3.104545 2.157102.261648c-.348863-.348864-.914488-.348864-1.263636 0L.261648.893466c-.348864.348864-.348864.914489 0 1.263636L3.104545 5 .261648 7.842898c-.348864.348863-.348864.914488 0 1.263636l.631818.631818c.348864.348864.914773.348864 1.263636 0L5 6.895455l2.842898 2.842897c.348863.348864.914772.348864 1.263636 0l.631818-.631818c.348864-.348864.348864-.914489 0-1.263636L6.895455 5z"
        />
      </svg>
    </a>
  </b-badge>
</template>

<script>
  export default {
    name: 'Badge',

    props: {
      withRemove: Boolean,
      dataCy: String,
    },

    data() {
      return {
        fillColor: this.$attrs.variant === 'dark' ? 'white' : 'black',
      };
    },
  };
</script>
